import React, {useState} from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import classnames from "classnames";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {usStates} from "../../utils/constants";
import {DefaultSettingsFees} from "./DefaultSettingsFees";
import {DefaultSettingsTaxes} from "./DefaultSettingsTaxes";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";

// Drop the menu directly below the control, left-aligned — same as the DealPage.
const selectMenuProps = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    marginThreshold: 4,
}


export const DefaultSettingsFeesAndTaxes = () => {
    // const [open, setOpen] = useState(false);
    const { quoteSettings } = useDefaultQuoteSettingsContext()

    const [usState, setUsState] = useState('ALL')

    const fees = quoteSettings.fees.filter(f => f.state === usState)

    return (
        <Box className={'ds-panel ds-panel-wide defaultSettingsBox'}>
            <div className={'ds-state-select-wrap'}>
                <span>Defaults for:</span>
                <Select
                    className={'ds-select-mui'}
                    value={usState}
                    MenuProps={selectMenuProps}
                    onChange={(e) => setUsState(e.target.value)}
                >
                    {['ALL', ...usStates].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt === 'ALL' ? 'All States' : opt}</MenuItem>
                    ))}
                </Select>
            </div>

            <DefaultSettingsFees
                fees={fees}
                usState={usState}
                setUsState={setUsState}
            />
            <DefaultSettingsTaxes
                fees={fees}
                usState={usState}
                setUsState={setUsState}
            />
        </Box>
    )
}